// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from "./core/CancelablePromise";
import { OpenAPI } from "./core/OpenAPI";
import { request as __request } from "./core/request";
import type {
  GetMediaMetadataData,
  GetMediaMetadataResponse,
  GetMediaMetadataBatchData,
  GetMediaMetadataBatchResponse,
} from "./types.gen";

export class MediaService {
  /**
   * Returns metadata about a media, including the poster, thumbnail, and sources.
   *
   * @param data The data for the request.
   * @param data.uuid UUID of the media.
   *
   * @returns MediaMetadata OK
   * @throws ApiError
   */
  public static getMediaMetadata(
    data: GetMediaMetadataData
  ): CancelablePromise<GetMediaMetadataResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/media/metadata/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * This is a convenience endpoint to get metadata for multiple media in a single request.
   *
   * @param data The data for the request.
   * @param data.uuids Comma separated list of UUIDs of the media. If any of the UUIDs are not found, the API will return a 404 error.
   * The maximum number of UUIDs that can be requested is 10. If more than 10 UUIDs are requested, the API will return a 400 error.
   *
   * @returns MediaMetadata OK
   * @throws ApiError
   */
  public static getMediaMetadataBatch(
    data: GetMediaMetadataBatchData
  ): CancelablePromise<GetMediaMetadataBatchResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/media/metadata",
      query: {
        uuids: data.uuids,
      },
    });
  }
}
